<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      data-slot="dropdown-menu-content"
      v-bind="forwarded"
      :side-offset="4"
      :class="
        cn(
          dropdownMenuContentVariants(),
          'max-h-(--reka-dropdown-menu-content-available-height) origin-(--reka-dropdown-menu-content-transform-origin) py-2',
          props.class,
        )
      "
    >
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import {
  DropdownMenuContent,
  type DropdownMenuContentEmits,
  type DropdownMenuContentProps as RekaDropdownMenuContentProps,
  DropdownMenuPortal,
  useForwardPropsEmits,
} from "reka-ui";
import type { HTMLAttributes } from "vue";
import { dropdownMenuContentVariants } from "./variants";
import { cn } from "@/lib/utils";

type DropdownMenuContentProps = Omit<
  RekaDropdownMenuContentProps,
  "sideOffset"
>;

const props = defineProps<
  DropdownMenuContentProps & { class?: HTMLAttributes["class"] }
>();
const emits = defineEmits<DropdownMenuContentEmits>();

const delegatedProps = reactiveOmit(props, "class");

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
